<template>
    <section class="modal-body-section-component" :class="customClass">
        <div class="modal-body-section-component__header" v-if="hasHeader">
            <div class="modal-body-section-component__heading">
                <div class="modal-body-section-component__icon" v-if="icon">
                    <i :class="icon"></i>
                </div>
                <div class="modal-body-section-component__title-block">
                    <span class="modal-body-section-component__eyebrow" v-if="eyebrow">{{ eyebrow }}</span>
                    <h6 v-if="title" :class="titleClass">{{ title }}</h6>
                    <small v-if="subtitle || $slots.subtitle">
                        <slot name="subtitle">{{ subtitle }}</slot>
                    </small>
                </div>
            </div>

            <div class="modal-body-section-component__actions" v-if="counter || $slots.actions">
                <slot name="actions">
                    <span class="modal-body-section-component__counter">{{ counter }}</span>
                </slot>
            </div>
        </div>

        <div class="modal-body-section-component__content">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ModalBodySectionComponent',
    props: {
        eyebrow: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        counter: {
            type: String,
            default: '',
        },
        customClass: {
            type: [String, Array, Object],
            default: '',
        },
        titleClass: {
            type: [String, Array, Object],
            default: '',
        },
    },
    computed: {
        hasHeader() {
            return this.eyebrow || this.title || this.subtitle || this.icon || this.counter || this.$slots.subtitle || this.$slots.actions;
        },
    },
}
</script>

<style scoped>
.modal-body-section-component {
    background: transparent;
    margin: 0;
    padding: 0;
}

.modal-body-section-component__header {
    align-items: flex-start;
    border-bottom: 1px solid #e4ebe8;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 14px;
}

.modal-body-section-component__heading {
    align-items: flex-start;
    display: flex;
    gap: 12px;
    min-width: 0;
}

.modal-body-section-component__icon {
    align-items: center;
    background: #e7f4f0;
    border: 0;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 38px;
    font-size: inherit;
    height: 38px;
    justify-content: center;
    width: 38px;
}

.modal-body-section-component__title-block {
    min-width: 0;
}

.modal-body-section-component__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .12em;
    margin-bottom: 2px;
    text-transform: uppercase;
}

.modal-body-section-component h6 {
    color: #173b34;
    font-size: 0.98rem;
    font-weight: 700;
    margin: 0 0 3px;
}

.modal-body-section-component small {
    color: #6b7c78;
}

.modal-body-section-component__counter {
    background: rgba(14, 94, 78, 0.08);
    border: 1px solid rgba(14, 94, 78, 0.12);
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 12px;
    white-space: nowrap;
}

:global(html.dark-theme .modal-body-section-component__header) {
    border-bottom-color: rgba(94, 234, 212, 0.14) !important;
}

:global(html.dark-theme .modal-body-section-component h6) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .modal-body-section-component__eyebrow) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .modal-body-section-component small) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .modal-body-section-component__icon),
:global(html.dark-theme .modal-body-section-component__counter) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

@media (max-width: 575px) {
    .modal-body-section-component__header {
        flex-direction: column;
    }

    .modal-body-section-component__actions,
    .modal-body-section-component__counter {
        align-self: flex-start;
    }
}
</style>
